<div class="add-line">
    <div class="circle">
        <span :class="`icon plus green m-auto ${iconClass}`"></span>
        <div class="bg"></div>
    </div>
</div>